import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangEnIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 18,
	viewBox: "0 0 18 18",
	width: 18,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z",
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.859 3.521a8.967 8.967 0 0 0-1.55 3.132H4.99zm15.827 3.132a8.967 8.967 0 0 0-1.55-3.132l-3.132 3.132zM.309 11.349a8.968 8.968 0 0 0 1.55 3.131l3.132-3.131zm14.168-9.488a8.968 8.968 0 0 0-3.131-1.55v4.682zM3.52 16.14c.92.707 1.98 1.24 3.131 1.55v-4.68zM6.651.31A8.968 8.968 0 0 0 3.52 1.862l3.13 3.131zm4.697 17.38a8.969 8.969 0 0 0 3.131-1.55l-3.131-3.131zm1.656-6.341 3.131 3.131a8.966 8.966 0 0 0 1.55-3.131z",
			fill: "#0052b4"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#d80027",
			children: [/* @__PURE__ */ _jsx("path", { d: "M17.924 7.826h-7.75V.076a9.089 9.089 0 0 0-2.348 0v7.75H.076a9.09 9.09 0 0 0 0 2.348h7.75v7.75a9.094 9.094 0 0 0 2.348 0v-7.75h7.75a9.093 9.093 0 0 0 0-2.348z" }), /* @__PURE__ */ _jsx("path", { d: "m11.348 11.347 4.016 4.016a9.66 9.66 0 0 0 .529-.578l-3.439-3.438zm-4.695.001-4.016 4.016c.184.184.377.36.578.529l3.438-3.439zm.002-4.696L2.638 2.636a9.02 9.02 0 0 0-.529.578l3.439 3.438h1.107zm4.693 0 4.016-4.017a9.003 9.003 0 0 0-.578-.529l-3.438 3.439z" })]
		})
	]
});
const ForwardRef = forwardRef(SvgLangEnIconmin);
export { ForwardRef as ReactComponent };
